import useNiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm
  from '../hooks/useNiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm';
import { ControlledRadioButton, ControlledSwitch } from '@@viewCommonComponents/controlled';
import { Collapse, ReimbursementChart, SectionTitle, TotalTable } from '@fasstech/middle-design-system';
import mapOfferNodeOptions from '@@viewHelpers/mapOfferNodeOptions';
import useChildren from '../hooks/useChildren.js';
import AddGrantee from './AddGrantee.jsx';
import extraMadelin from '../extra/extraMadelin.js';
import FranchiseRadioSection from './FranchiseRadioSection.jsx';
import GuaranteeOptionSwitch from './GuaranteeOptionSwitch.jsx';
import { calculateDailyRevenue } from '../hooks/helpers/intervalsHelpers.js';
import TotalTableSkeleton from './TotalTableSkeleton.jsx';

const NiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm = ({
  form,
  guarantees,
  pricesGuarantees,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  minBirthDateReducChild,
  maxBirthDateReducChild,
  minBirthDateHospiChild,
  maxBirthDateHospiChild,
  onOptionFrMalChange,
  onOptionFrAccChange,
  onOptionFrHospChange,
  annualIncome,
  PASS,
  registerComputedFranchiseDataGetter,
  pricesLoading
}) => {
  const {
    optionFraisGeneraux,
    watchedWarrantyFields,
    isGarIncapRequired,
    childErrorHospi,
    garIncap,
    incapHospiChild,
    childrenGuaranteeIsRequired,
    OPTION_INCAP,
    INCAP_MAD,
    OPTION_ZERO_SIN,
    OPTION_EXO_COT,
    OPTION_CONFORT_PSY,
    OPTION_HOSP_ENF_GAR,
    HOSP_ENF_MAD,
    OPTION_FR_GEN,
    HOSP_ENF_ALLOW_AMOUNT,
    incapCotisation,
    updateRadioButtonSelectedIndex,
    resetIncapSubOptionsWhenDisabled,
    labels,
    tabs,
    parsedHealthInsurances,
    parsedROs,
    graphRows,
    graphNote,
    getComputedFranchiseData
  } = useNiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm({
    form,
    guarantees,
    pricesGuarantees,
    getMiddleText,
    getMiddleBoolean,
    annualIncome,
    PASS
  });

  if (registerComputedFranchiseDataGetter) {
    registerComputedFranchiseDataGetter(getComputedFranchiseData);
  }

  const {
    children,
    childIsRequired,
    addChild,
    deleteChild,
    childHasBirthDate,
    setEditingChild,
    isChildMaxCountReached,
    nbMaxChild,
    maxGranteeAgeIncapHospiChild,
    minChildPickerBirthDate,
    maxChildPickerBirthDate
  } = useChildren({
    form,
    getMiddleNumber,
    getMiddleText,
    minBirthDateReducChild,
    maxBirthDateReducChild,
    minBirthDateHospiChild,
    maxBirthDateHospiChild
  });
  return (
    <Collapse title={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_LABEL')}>
      <div className="flex gap-10 flex-col-reverse md:flex-row">
        {/*Left column*/}
        <div className="flex-1">
          <ControlledSwitch
            name="guarantees.OPTION_INCAP.selected"
            label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_CHOIX_LABEL')}
            labelClassNames="text-lg"
            rules={isGarIncapRequired(watchedWarrantyFields)}
            displayError={false}
            disabled={!OPTION_INCAP.editable}
            form={form}
            extraClick={resetIncapSubOptionsWhenDisabled}
            recommended={OPTION_INCAP.recommended}
            infoMessage={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_MESSAGE_INFO')}
            data-testid="OPTION_INCAP"
          />

          {garIncap && (
            <>
              <hr className="mt-8 mb-6"/>

              <div className="grid grid-cols-1 md:grid-cols-3! gap-8 md:grid-flow-dense">
                <FranchiseRadioSection
                  configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_MALADIE_EST_NECESSAIRE"
                  labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_MALADIE_LABEL"
                  infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_MALADIE_MESSAGE_INFO"
                  name="guarantees.OPTION_FR_MAL.value"
                  guarantee={guarantees.OPTION_FR_MAL}
                  extraChange={onOptionFrMalChange}
                  form={form}
                  getMiddleText={getMiddleText}
                  getMiddleBoolean={getMiddleBoolean}
                />
                <FranchiseRadioSection
                  configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_ACCIDENT_EST_NECESSAIRE"
                  labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_ACCIDENT_LABEL"
                  infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_ACCIDENT_MESSAGE_INFO"
                  name="guarantees.OPTION_FR_ACC.value"
                  guarantee={guarantees.OPTION_FR_ACC}
                  extraChange={onOptionFrAccChange}
                  form={form}
                  getMiddleText={getMiddleText}
                  getMiddleBoolean={getMiddleBoolean}
                />

                {getMiddleBoolean('ADHERENT_CAISSE_PRO_EST_NECESSAIRE') && (
                  <div className="md:col-start-3 md:row-span-2">
                    <ReimbursementChart
                      healthInsurances={parsedHealthInsurances}
                      labels={labels}
                      ROs={parsedROs}
                      rows={graphRows}
                      note={graphNote}
                      {...(tabs && { tabs })}
                      dailyRevenue={calculateDailyRevenue(annualIncome)}
                      displayGraph
                    />
                  </div>
                )}

                <FranchiseRadioSection
                  configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_HOSPITALISATION_EST_NECESSAIRE"
                  labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_HOSPITALISATION_LABEL"
                  infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_HOSPITALISATION_MESSAGE_INFO"
                  name="guarantees.OPTION_FR_HOSP.value"
                  guarantee={guarantees.OPTION_FR_HOSP}
                  extraChange={onOptionFrHospChange}
                  form={form}
                  getMiddleText={getMiddleText}
                  getMiddleBoolean={getMiddleBoolean}
                />
                <FranchiseRadioSection
                  configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_TTES_CAUSES_EST_NECESSAIRE"
                  labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_TTES_CAUSES_LABEL"
                  infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_TTES_CAUSES_MESSAGE_INFO"
                  name="guarantees.OPTION_FR_ALL.value"
                  guarantee={guarantees.OPTION_FR_ALL}
                  form={form}
                  getMiddleText={getMiddleText}
                  getMiddleBoolean={getMiddleBoolean}
                />
              </div>

              <SectionTitle>
                {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_CAPITAL_LABEL')}
              </SectionTitle>
              <div>
                <ControlledRadioButton
                  withIndicator={false}
                  isMultiline
                  isResponsiveCol
                  form={form}
                  name="guarantees.OPTION_INCAP_CAP.value"
                  options={mapOfferNodeOptions(guarantees.OPTION_INCAP_CAP)}
                  data-testid="OPTION_INCAP_CAP"
                  extraChange={updateRadioButtonSelectedIndex('OPTION_INCAP_CAP')}
                />
              </div>
              <p className="mb-4">
                {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_CAPITAL_LEGENDE')}
              </p>

              {INCAP_MAD && (
                <ControlledSwitch
                  extraClick={() => extraMadelin(INCAP_MAD.selected, form)}
                  name="guarantees.INCAP_MAD.selected"
                  label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FISCA_MADELIN_LABEL')}
                  containerClassName="mb-8"
                  labelClassNames="text-lg"
                  disabled={!INCAP_MAD.editable}
                  form={form}
                  displayError={false}
                  data-testid="INCAP_MAD"
                />
              )}

              <hr className="mb-6"/>

              {getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EST_NECESSAIRE') && (
                <>
                  <SectionTitle>
                    {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_LABEL')}
                  </SectionTitle>

                  <GuaranteeOptionSwitch
                    guarantee={OPTION_ZERO_SIN}
                    code="OPTION_ZERO_SIN"
                    configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_ZERO_SINISTRE_EST_NECESSAIRE"
                    labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_ZERO_SINISTRE_LABEL"
                    infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_ZERO_SINISTRE_MESSAGE_INFO"
                    form={form}
                    getMiddleText={getMiddleText}
                    getMiddleBoolean={getMiddleBoolean}
                  />

                  <GuaranteeOptionSwitch
                    guarantee={OPTION_EXO_COT}
                    code="OPTION_EXO_COT"
                    configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EXO_COTISATION_EST_NECESSAIRE"
                    labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EXO_COTISATION_LABEL"
                    infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EXO_COTISATION_MESSAGE_INFO"
                    form={form}
                    getMiddleText={getMiddleText}
                    getMiddleBoolean={getMiddleBoolean}
                  />

                  <GuaranteeOptionSwitch
                    guarantee={OPTION_CONFORT_PSY}
                    code="OPTION_CONFORT_PSY"
                    configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_CONFORT_PSY_EST_NECESSAIRE"
                    labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_CONFORT_PSY_LABEL"
                    infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_CONFORT_PSY_MESSAGE_INFO"
                    form={form}
                    getMiddleText={getMiddleText}
                    getMiddleBoolean={getMiddleBoolean}
                  />

                  <GuaranteeOptionSwitch
                    guarantee={OPTION_HOSP_ENF_GAR}
                    code="OPTION_HOSP_ENF_GAR"
                    configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_EST_NECESSAIRE"
                    labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_LABEL"
                    infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_MESSAGE_INFO"
                    form={form}
                    getMiddleText={getMiddleText}
                    getMiddleBoolean={getMiddleBoolean}
                    rules={childIsRequired(children, childErrorHospi)}
                  />

                  {incapHospiChild && (
                    <>
                      <AddGrantee
                        icon="stroller"
                        title="Enfant(s)"
                        buttonTitle={'Ajouter des enfants'}
                        infoTooltip={getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_INFO',
                          {
                            maxGranteeAge: maxGranteeAgeIncapHospiChild
                          }
                        )}
                        grantees={children}
                        addGrantee={addChild}
                        deleteGrantee={deleteChild}
                        setEditingGrantee={setEditingChild}
                        granteeHasBirthDate={childHasBirthDate}
                        form={form}
                        minBirthDate={minBirthDateHospiChild}
                        maxBirthDate={maxBirthDateHospiChild}
                        minPickerBirthDate={minChildPickerBirthDate}
                        maxPickerBirthDate={maxChildPickerBirthDate}
                        isMaxCountReached={isChildMaxCountReached}
                        maxCountMessage={getMiddleText('BENEFICIAIRE_TYPE_MAX_CHILD_ATTEINT', {
                          nbMaxChild
                        })}
                        formName={'children'}
                        dataTestId="childHospi"
                        getMiddleText={getMiddleText}
                      />
                      <div>
                        <p className="font-bold">
                          {getMiddleText(
                            'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_MT_IJ_LABEL'
                          )}
                        </p>
                        <ControlledRadioButton
                          withIndicator={false}
                          isMultiline
                          isResponsiveCol
                          form={form}
                          name="guarantees.HOSP_ENF_ALLOW_AMOUNT.value"
                          size="small"
                          options={mapOfferNodeOptions(HOSP_ENF_ALLOW_AMOUNT)}
                          rules={childrenGuaranteeIsRequired}
                          data-testid="HOSP_ENF_ALLOW_AMOUNT"
                        />
                      </div>

                      {HOSP_ENF_MAD && (
                        <ControlledSwitch
                          extraClick={() => extraMadelin(HOSP_ENF_MAD.selected, form)}
                          name="guarantees.HOSP_ENF_MAD.selected"
                          label={getMiddleText(
                            'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_FISCA_MADELIN_LABEL'
                          )}
                          containerClassName="ml-3 mb-4"
                          labelClassNames="text-lg"
                          disabled={!HOSP_ENF_MAD.editable}
                          form={form}
                          displayError={false}
                          data-testid="HOSP_ENF_MAD"
                        />
                      )}
                    </>
                  )}
                </>
              )}

              <hr className="mt-6 mb-4"/>

              {OPTION_FR_GEN &&
                getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_EST_NECESSAIRE'
                ) && (
                <>
                  <ControlledSwitch
                    name="guarantees.OPTION_FR_GEN.selected"
                    label={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_LABEL'
                    )}
                    containerClassName="ml-3 mb-4"
                    labelClassNames="text-lg font-bold"
                    disabled={!OPTION_FR_GEN.editable}
                    form={form}
                    displayError={false}
                    recommended={OPTION_FR_GEN.recommended}
                    infoMessage={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_MESSAGE_INFO'
                    )}
                    data-testid="OPTION_FR_GEN"
                  />

                  {optionFraisGeneraux && (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2! gap-8 md:grid-flow-dense">
                        <FranchiseRadioSection
                          configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_MALADIE_EST_NECESSAIRE"
                          labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_MALADIE_LABEL"
                          infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_MALADIE_MESSAGE_INFO"
                          name="guarantees.OPTION_FR_GEN_FR_MAL.value"
                          guarantee={guarantees.OPTION_FR_GEN_FR_MAL}
                          form={form}
                          getMiddleText={getMiddleText}
                          getMiddleBoolean={getMiddleBoolean}
                        />
                        <FranchiseRadioSection
                          configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_ACCIDENT_EST_NECESSAIRE"
                          labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_ACCIDENT_LABEL"
                          infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_ACCIDENT_MESSAGE_INFO"
                          name="guarantees.OPTION_FR_GEN_FR_ACC.value"
                          guarantee={guarantees.OPTION_FR_GEN_FR_ACC}
                          form={form}
                          getMiddleText={getMiddleText}
                          getMiddleBoolean={getMiddleBoolean}
                        />

                        <FranchiseRadioSection
                          configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_HOSPITALISATION_EST_NECESSAIRE"
                          labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_HOSPITALISATION_LABEL"
                          infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_HOSPITALISATION_MESSAGE_INFO"
                          name="guarantees.OPTION_FR_GEN_FR_HOSP.value"
                          guarantee={guarantees.OPTION_FR_GEN_FR_HOSP}
                          form={form}
                          getMiddleText={getMiddleText}
                          getMiddleBoolean={getMiddleBoolean}
                        />
                        <FranchiseRadioSection
                          configKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_TTES_CAUSES_EST_NECESSAIRE"
                          labelKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_TTES_CAUSES_LABEL"
                          infoKey="NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_TTES_CAUSES_MESSAGE_INFO"
                          name="guarantees.OPTION_FR_GEN_FR_TT_CAUSE.value"
                          guarantee={guarantees.OPTION_FR_GEN_FR_TT_CAUSE}
                          form={form}
                          getMiddleText={getMiddleText}
                          getMiddleBoolean={getMiddleBoolean}
                        />
                      </div>

                      <p className="font-bold">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_CAPITAL_LABEL'
                        )}
                      </p>
                      <div>
                        <ControlledRadioButton
                          withIndicator={false}
                          isMultiline
                          isResponsiveCol
                          name="guarantees.FR_GEN_CAP.value"
                          options={mapOfferNodeOptions(form.watch('guarantees.FR_GEN_CAP'))}
                          form={form}
                          data-testid="FR_GEN_CAP"
                          extraChange={updateRadioButtonSelectedIndex('FR_GEN_CAP')}
                        />
                      </div>
                      <p className="mb-4">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_CAPITAL_LEGENDE'
                        )}
                      </p>
                    </>
                  )}
                </>
              )}

              {pricesLoading
                ? <TotalTableSkeleton rowCount={incapCotisation.length}/>
                : <TotalTable rows={incapCotisation}/>}
            </>
          )}
        </div>
      </div>
    </Collapse>
  );
};

export default NiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm;
